import { getAction, listAction, createAction, deleteAction, updateAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { Faq } from "../classes/faq.class";

/**
 * Gets a center entry.
 */
export const getFaqEntry = function (value, slugOrId, recursive) {
	return getAction( "faqs", value, slugOrId, recursive).then(data => {
		return processEntry(data.data[0]);
	});
}

/**
 * Gets a list of centers.
 */
export const getFaqsList = function (recursive, page, author) {
	return listAction("faqs", recursive, page).then(data => {
		
		return { content: processList(data.data), totalEntries: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Process data.
 */
const processData = function(data) {
	let content = data.data;
	return content;
}

/**
 * Process Entry.
 */
const processEntry = function(data) {
	let content = new Faq( data );

	return content;
}

/**
 * Process List.
 */
const processList = function(data) {
	let content = data;

	content = content.map(value => {
		return processEntry(value)
	})

	return content;
}



// WEBPACK FOOTER //
// ./src/data/models/faq.model.js